import React, { useEffect, useState } from 'react';
import { Text, Card, Site } from "tabler-react";
import './Unsubscribe.css';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

type UnsubscribeStatus = 'loading' | 'success' | 'error';

function Unsubscribe() {
  const location = useLocation();
  const [status, setStatus] = useState<UnsubscribeStatus>('loading');

  useEffect(() => {
    (async () => {
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get('token');

      if (!token) {
        console.error('No token found in the URL');
        setStatus('error');
        return;
      }

      try {
        // Endpoint público de opt-out: não exige autenticação de admin.
        // O token vem da URL do e-mail e é enviado no corpo da requisição.
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/unsubscribe`,
          { token },
        );

        if (response.data && response.data.success) {
          setStatus('success');
        } else {
          setStatus('error');
        }
      } catch (error) {
        console.error('Erro ao processar o descadastro:', error);
        setStatus('error');
      }
    })();
  }, [location.search]);

  return (
    <div className="unsubscribe-wrapper">
      <Site.Header
        href="/"
        alt="Fidegg"
        imageURL="/img/logo.svg"
        align="center"
      />
      <div className="content-unsubscribe">
        {status === 'loading' && (
          <Card.Body className="card-body-unsubscribe">
            <Text className="text-content-unsubscribe">
              Processando seu descadastro...
            </Text>
          </Card.Body>
        )}

        {status === 'success' && (
          <>
            <img src="/img/icon_sad_face.svg" alt="Sad Face" className="sad-icon-unsubscribe" />
            <Card.Body className="card-body-unsubscribe">
              <Text className="text-content-unsubscribe">
                Agradecemos por ter feito parte da nossa comunidade!
                Sentiremos sua falta, mas respeitamos sua decisão.
              </Text>
            </Card.Body>
          </>
        )}

        {status === 'error' && (
          <Card.Body className="card-body-unsubscribe">
            <Text className="text-content-unsubscribe text-content-unsubscribe--error">
              Não foi possível concluir o seu descadastro. O link pode ser inválido
              ou ter expirado. Tente novamente pelo link mais recente do e-mail.
            </Text>
          </Card.Body>
        )}
      </div>
    </div>
  );
}

export default Unsubscribe;
